import React from "react";
import {
  ComponentProjectListPageContent,
  ComponentProjectListPageStateProvider,
} from ".";
import { AddCmpProjectDialogStateProvider } from "../dialog/add-cmp-project-dialog";

export const ComponentProjectListPage = () => {
  return (
    <>
      <ComponentProjectListPageStateProvider>
        <AddCmpProjectDialogStateProvider>
          <ComponentProjectListPageContent />
        </AddCmpProjectDialogStateProvider>
      </ComponentProjectListPageStateProvider>
    </>
  );
};
